import React from 'react';
import SideNav, { V2NavSection } from '../../components/navigation/SideNav';
import './DashboardLayout.css';

interface DashboardLayoutProps {
  activeSection: V2NavSection;
  children: React.ReactNode;
  wide?: boolean;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  activeSection,
  children,
  wide = false,
}) => {
  return (
    <div className="v2-dashboard-layout">
      <SideNav activeSection={activeSection} />

      <main className="v2-dashboard-layout__main">
        <div className={`v2-dashboard-layout__content ${wide ? 'v2-dashboard-layout__content--wide' : ''}`}>
          {children}
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
